<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PlanningMixin",
  data() {
    return {
      title: "",
      planning: [],
      current: {},
      // PAGINATION
      pageCount: 1,
      totalRows: 0,
      visibleRows: 10,
      page: parseInt(this.$route.query.page) || 1,
      // FILTERS
      showingActivePlannings: true,
      filters: {
        fabricaAsignada: false,
        agenteAsignado: false,
        idFactory: null,
        idFactoryAgent: null,
        searchReference: null,
        idClient: null,
        idCollection: null,
        client: null,
        idUser: null
      },
      // CALENDAR DATES
      attrs: [],
      isFiltering:false
    };
  },
  computed: {
    ...mapState("planning", [
      "clients",
      "collections",
      "factories",
      "agents",
      "recordsUrl",
      "paginationUrl"
    ]),
    totalPlannings() {
      return Object.keys(this.planning).length;
    }
  },
  methods: {
    ...mapActions("planning", [
      "fetchClients",
      "fetchCollections",
      "fetchFactories",
      "fetchAgents"
    ]),
    /**
     *  Stores the TotalRecords and Pagination URLs into VUEX.
     */
    setPaginationUrls(paginationUrl, recordsUrl) {
      this.$store.commit("planning/SET_RECORDS_URL", recordsUrl);
      this.$store.commit("planning/SET_PAGINATION_URL", paginationUrl);
    },
    fetchPaginationData(value) {
      if (value == "next") this.page += 1;
      else if (value == "previous") this.page -= 1;
      else if(typeof value== 'number') {
            this.page = value;
            if(this.isFiltering){
                this.filterPlannings();
                return;
            }
      }else{
          this.page = 1;
      }
      this.fetchPlanning();
    },
    fetchPlanning() {
      this.$axios
        .get(this.recordsUrl)
        .then((response) => {
          this.totalRows = response.data;
          this.pageCount = Math.ceil(this.totalRows / this.visibleRows);
        })
        .finally(() => {
          this.$axios
            .post(this.paginationUrl, {
              page: this.page,
              take: this.visibleRows
            })
            .then((response) => {
              this.planning = response.data;
            });
        });

      if (this.clients.length == 0) this.fetchClients();
      if (this.collections.length == 0) this.fetchCollections();
      if (this.factories.length == 0) this.fetchFactories();
      if (this.agents.length == 0) this.fetchAgents();
    },
    /**
     *  Returns the basic Planning Filters refactored so that the API can perform the Query.
     */
    getPlanningFilterParams() {
      let params = {
        fabricaAsignada: this.filters.fabricaAsignada,
        agenteAsignado: this.filters.agenteAsignado,
        idClient: this.filters.idClient || 0,
        idCollection: this.filters.idCollection || 0,
        idFactory: this.filters.idFactory || 0,
        idFactoryAgent: this.filters.idFactoryAgent || 0,
        client: this.user.rol == "CLIENTE",
        idUser: this.user.id
      };

      if (this.filters.searchReference != null) {
        params.referenceSergio = this.filters.searchReference;
      }

      return params;
    },
    /**
     *  Filter plannings by all the options selected. Save the urls to Vuex state.
     */
    filterPlannings(paginationUrl, recordsUrl) {
      let params = this.getPlanningFilterParams();
      params.page = this.page;
      params.take = this.visibleRows;
      if (paginationUrl!==undefined&&recordsUrl!==undefined){
          this.setPaginationUrls(paginationUrl, recordsUrl);
      }

      // Hay un filtro que es GET y el resto son POST.
      let method = this.recordsUrl.includes('TotalRegistrosGetBy') ? 'POST' : 'GET';

      // TOTAL REGISTROS SON GET. IGUAL EN UN FUTURO QUIEREN DESCATALOGADAS CON FILTROS.
      this.$axios({
        method: method,
        url: this.recordsUrl,
        data: params
      }).then((response) => {
          this.totalRows = response.data;
          this.pageCount = Math.ceil(this.totalRows / this.visibleRows);
        })
        .finally(() => {
          this.$axios.post(this.paginationUrl, params).then((response) => {
            this.planning = response.data;
            this.openAlert("success", "Plannings filtrados", null);
          });
        });
    },
    getDiscontinuedPlannings(paginationUrl, recordsUrl) {
      this.setTitle(paginationUrl, "discontinued");
      this.filterPlannings(paginationUrl, recordsUrl);
      this.fetchPlanning();
      this.showingActivePlannings = false;
    },
    removeFilters(paginationUrl, recordsUrl) {
      this.setTitle(paginationUrl, "allPlannings");
      this.setPaginationUrls(paginationUrl, recordsUrl);
      this.fetchPlanning();
      this.showingActivePlannings = true;
      this.page=1;
      this.resetFilters();
    },
    resetFilters() {
      this.filters = {
        searchReference: null,
        fabricaAsignada: false,
        agenteAsignado: false,
        idClient: null,
        idCollection: null,
        idFactory: null,
        idFactoryAgent: null,
        client: this.user.rol == "CLIENTE",
        idUser: this.user.id
      };
    },
    takeRows(visibleRows) {
      this.visibleRows = visibleRows;
      this.fetchPaginationData(visibleRows);
    },
    /**
     *  Changes the Planning title depending from where we are navigating.
     */
    setTitle(url, type) {
      if (url.includes("ComercialRequests")) {
        if (type == "discontinued") {
          this.title = this.$t("lang.msg.discontinuedComercialRequests");
        } else if (type == "allPlannings") {
          this.title = this.$t("lang.msg.comercialRequestPlannings");
        }
      } else if (url.includes("Designs")) {
        if (type == "discontinued") {
          this.title = this.$t("lang.msg.discontinuedDesigns");
        } else if (type == "allPlannings") {
          this.title = this.$t("lang.msg.designPlannings");
        }
      } else if (url.includes("Samples")) {
        if (type == "discontinued") {
          this.title = this.$t("lang.msg.discontinuedSamples");
        } else if (type == "allPlannings") {
          this.title = this.$t("lang.msg.samplePlannings");
        }
      } else {
        if (type == "discontinued") {
          this.title = this.$t("lang.msg.discontinuedProductions");
        } else if (type == "allPlannings") {
          this.title = this.$t("lang.msg.productionPlannings");
        }
      }
    }
  }
};
</script>
